export default class InteractiveContainerEvent extends Event {
	/**
	 * The static BLURRED type is dispatched if the InteractiveContainer is focused and looses focus.
	 *
	 * Example: addEventListener(InteractiveContainerEvent.BLURRED, (event: InteractiveContainerEvent) => {});
	 */
	public static BLURRED = 'InteractiveContainerEvent.blurred';
	/**
	 * The static FOCUSED type is dispatched when the InteractiveContainer is focused with a Pointer click or being tabbed into.
	 *
	 * Example: addEventListener(InteractiveContainerEvent.FOCUSED, (event: InteractiveContainerEvent) => {});
	 */
	public static FOCUSED = 'InteractiveContainerEvent.focused';
	/** The static HOVERED type is dispatched when the user moves a pointing device over the InteractiveContainer. */
	public static HOVERED = 'InteractiveContainerEvent.hovered';
	/** The static UN_HOVERED type is dispatched when the user moves a pointing device away from the InteractiveContainer. */
	public static UN_HOVERED = 'InteractiveContainerEvent.unhovered';
	public constructor(type: string) {
		assertIsValidType(type);
		super(type, { bubbles: true });
	}
}

function assertIsValidType(value: unknown): asserts value is string {
	if (value === InteractiveContainerEvent.BLURRED || value === InteractiveContainerEvent.FOCUSED || value === InteractiveContainerEvent.HOVERED || value === InteractiveContainerEvent.UN_HOVERED) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be BLURRED, FOCUSED, HOVERED or UN_HOVERED`);
}
